import { render, staticRenderFns } from "./InsLayer.vue?vue&type=template&id=12bd570e&scoped=true&"
import script from "./InsLayer.vue?vue&type=script&lang=ts&"
export * from "./InsLayer.vue?vue&type=script&lang=ts&"
import style0 from "./InsLayer.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InsLayer.vue?vue&type=style&index=1&id=12bd570e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd570e",
  null
  
)

export default component.exports